export const CampaignStatusEnum = Object.freeze({
    Scheduled: 0,
    Starting: 1,
    Started: 2,
    Ending: 3,
    Ended: 4,
    FailedActivating: 5,
    FailedDeactivating: 6,
    FailedTooManyProducts: 7,
    SyncingProducts: 8,
    PendingUpgrade: 9
  });